export default __webpack_public_path__ + "static/media/product_info_banner_Hk.65f9421f.webp";